import { apiConfig } from '../config/api';
import { getAccessToken } from './auth';

/**
 * `<img src>` / anchor download 처럼 axios interceptor 를 타지 않아 브라우저가
 * Authorization 헤더를 못 붙이는 요청을 위한 인증 미디어 URL 빌더.
 *
 * 백엔드 `AuthMiddlewareAllowQueryToken` 가 받는 `?token=` 쿼리에 현재 access
 * token 을 실어 보낸다. 헤더가 있으면 백엔드가 헤더를 우선하므로 안전.
 *
 * - 상대경로(`/v0.1/...`)는 `apiConfig.BASE_URL` 을 붙여 절대화 — API 가
 *   cross-origin 으로 떠 있을 때 `<img>` 가 백엔드로 가도록 보장.
 * - 이미 쿼리(예: 캐시버스팅 `?v=...`)가 있으면 `&token=`, 없으면 `?token=`.
 * - 토큰이 없으면(미로그인) 쿼리 없이 반환 — 백엔드가 401 로 응답.
 *
 * SitePhotoService.fileUrl 과 동일 패턴을 공용화한 것 (프로필 아바타·작성자 칩 공유).
 */
export function withMediaToken(path: string): string {
  if (!path) return path;
  const base = /^https?:\/\//i.test(path) ? path : `${apiConfig.BASE_URL}${path}`;
  const token = getAccessToken();
  if (!token) return base;
  const sep = base.includes('?') ? '&' : '?';
  return `${base}${sep}token=${encodeURIComponent(token)}`;
}
